import { IsString } from "class-validator";

export class PasswordResetRequestDto {
  @IsString()
  readonly email: string;
}
